// @flow
import { APICore } from './apiCore';
import config from '../../config';
import { buildQueryParams } from './common-financials-analytics';

const api = new APICore();

const BASE_URL = config.SHIPMENT_FINANCIALS_ANALYTICS_URL;

const makeApiCall = (endpoint, query): Promise<any> => {
    if (typeof query === 'string') {
        return api.get(`${BASE_URL}${endpoint}?${query}`, {}, {});
    }
    const queryParams = buildQueryParams(query);
    return api.get(`${BASE_URL}${endpoint}`, queryParams, {});
};

function getCharges(query): any {
    const endpoint = '/charges';
    return makeApiCall(endpoint, query);
}

function getAdjustments(query): any {
    const endpoint = '/adjustments';
    return makeApiCall(endpoint, query);
}

function getAdjustmentsReport(query): any {
    const endpoint = '/adjustments_report';
    return api.getFile(`${BASE_URL}${endpoint}?${query}`);
}

function getCustomAdjustments(query): any {
    const endpoint = '/custom_adjustments';
    return makeApiCall(endpoint, query);
}

function getCustomAdjustmentsReport(query): any {
    const endpoint = '/custom_adjustments_report';
    return api.getFile(`${BASE_URL}${endpoint}?${query}`);
}

function getMargins(query): any {
    const endpoint = '/margins';
    return makeApiCall(endpoint, query);
}

function getMarginsReport(query): any {
    const endpoint = '/margins_report';
    return api.getFile(`${BASE_URL}${endpoint}?${query}`);
}

function getVerifiedMargins(query): any {
    const endpoint = '/verified_margins';
    return makeApiCall(endpoint, query);
}

function getVerifiedMarginsReport(query): any {
    const endpoint = '/verified_margins_report';
    return api.getFile(`${BASE_URL}${endpoint}?${query}`);
}

export {
    getCharges,
    getAdjustments,
    getAdjustmentsReport,
    getCustomAdjustments,
    getCustomAdjustmentsReport,
    getMargins,
    getMarginsReport,
    getVerifiedMargins,
    getVerifiedMarginsReport,
};
